import { ColumnConfig, ColumnDataType, getFieldValuesFromEnum } from '@aurora';
import { TranslocoService } from '@jsverse/transloco';
import { DigitaiFleetAircraftEngineStatus } from '../digitai.types';

export const fleetAircraftEngineColumnsConfig: (
    translocoService?: TranslocoService
) => ColumnConfig[] = (translocoService: TranslocoService) => [
    {
        type: ColumnDataType.ENUM,
        field: 'status',
        sort: 'status',
        translation: 'digitai.Status',
        fieldValues: () =>
            getFieldValuesFromEnum(
                DigitaiFleetAircraftEngineStatus,
                (value) =>
                    `${translocoService && translocoService.translate('digitai.EngineStatus.' + value)}`
            ),
    },
    {
        type: ColumnDataType.STRING,
        field: 'serialNumber',
        searchableField: '$DigitaiFleetAircraftEngine.serialNumber$',
        sort: 'serialNumber',
        translation: 'digitai.SerialNumber',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.STRING,
        field: 'engineModel.name',
        searchableField: '$engineModel.name$',
        sort: 'engineModel.name',
        translation: 'digitai.EngineModelName',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.STRING,
        field: 'fleetAircraft.plate',
        searchableField: '$fleetAircraft.plate$',
        sort: 'fleetAircraft.plate',
        translation: 'digitai.FleetAircraftPlate',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.STRING,
        field: 'fleetAircraft.serialNumber',
        searchableField: '$fleetAircraft.serialNumber$',
        sort: 'fleetAircraft.serialNumber',
        translation: 'digitai.FleetAircraftSerialNumber',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.NUMBER,
        field: 'position',
        sort: 'position',
        translation: 'digitai.Position',
    },
    {
        type: ColumnDataType.STRING,
        field: 'company.tenant.name',
        searchableField: '$company.tenant.name$',
        sort: 'company.tenant.name',
        translation: 'digitai.Company',
        isUnaccent: true,
    },
];

export const fleetAircraftEngineDialogColumnsConfig: ColumnConfig[] = [
    {
        type: ColumnDataType.NUMBER,
        field: 'position',
        sort: 'position',
        translation: 'digitai.Position',
    },
    {
        type: ColumnDataType.STRING,
        field: 'serialNumber',
        sort: 'serialNumber',
        translation: 'digitai.SerialNumber',
        isUnaccent: true,
    },
];

export const fleetAircraftEnginePullDialogColumnsConfig: ColumnConfig[] = [
    {
        type: ColumnDataType.STRING,
        field: 'serialNumber',
        sort: 'serialNumber',
        translation: 'digitai.SerialNumber',
        isUnaccent: true,
    },
];

export const alertLogEngineDialogColumnsConfig: ColumnConfig[] = [
    {
        type: ColumnDataType.STRING,
        field: 'serialNumber',
        searchableField: 'serialNumber',
        sort: 'serialNumber',
        translation: 'digitai.SerialNumber',
        isUnaccent: true,
    },
    {
        type: ColumnDataType.NUMBER,
        field: 'position',
        sort: 'position',
        translation: 'digitai.Position',
    },
    {
        type: ColumnDataType.ENUM,
        field: 'status',
        sort: 'status',
        translation: 'digitai.Status',
    },
];
